import React from "react";

const Affiliation = () => {
    const portfolioImages = [
        { id: 1, src: "Adeha/Adeha1.png", alt: "Adeha Product 1" },
        { id: 2, src: "Adeha/Adeha2.png", alt: "Adeha Product 2" },
        { id: 3, src: "Adeha/Adeha3.png", alt: "Adeha Product 3" },
    ];

    return (
        <div
            style={{
                padding: "50px",
                backgroundColor: "#f8f9fa", // Light background
                borderRadius: "15px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                margin: "50px 0",
            }}
        >
            {/* Title Section */}
            <h2
                style={{
                    fontSize: "36px",
                    fontWeight: "bold",
                    color: "#703593", // Vivid Violet
                    textAlign: "center",
                    marginBottom: "20px",
                }}
            >
                Our Affiliation
            </h2>
            <p
                style={{
                    fontSize: "18px",
                    lineHeight: "1.8",
                    color: "#415979", // East Bay
                    textAlign: "center",
                    marginBottom: "40px",
                }}
            >
                We take pride in providing end-to-end development and manufacturing solutions for emerging brands like "ADEHA." From design to production, we ensure quality and innovation in every step.
            </p>

            {/* Portfolio Section */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "20px",
                }}
            >
                {portfolioImages.map((image, index) => (
                    <div
                        key={image.id}
                        style={{
                            flex: index === 1 ? "2" : "1", // Middle image is broader
                            borderRadius: "15px",
                            overflow: "hidden",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                        }}
                    >
                        <img
                            src={image.src}
                            alt={image.alt}
                            style={{
                                width: "100%",
                                height: "280px",
                                objectFit: "cover",
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Affiliation;
